import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading text-primary-400">韩漫星球</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              韩漫星球致力于为广大漫画爱好者提供韩漫免费阅读和无删减漫画下拉式阅读体验。我们精心挑选好看的韩国漫画大全，涵盖多种类型，让每位读者都能找到自己喜欢的作品。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              {categories.map(cat => (
                <li key={cat.slug}>
                  <Link
                    to={'/category/' + cat.slug}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">关于我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">隐私政策</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">使用条款</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">帮助中心</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@manhuastar.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>中国·北京</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-400"></i>
                <span>每日更新 24小时在线</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-white transition-colors duration-200" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-white transition-colors duration-200" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-white transition-colors duration-200" rel="nofollow" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 韩漫星球 manhuastar.com - 韩漫免费阅读平台。本站所有漫画均来自网络，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200">DMCA</a>
          </div>
        </div>
      </div>
    </footer>
  );
}